// removed by extract-text-webpack-plugin
module.exports = {"root":"ResponsiveImage-example__root__nEWrG","aspectWrapper":"ResponsiveImage-example__aspectWrapper__1N5_E","rootForImageWithAspectRatio":"ResponsiveImage-example__rootForImageWithAspectRatio__gumCe","rootForSizes":"ResponsiveImage-example__rootForSizes__2wr6u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResponsiveImage/ResponsiveImage.example.css
// module id = 2449
// module chunks = 0